module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-Bold.6543dcb.woff";